import { Outlet } from "react-router-dom";
import TabBar from "../../components/tabbar/TabBar";
import "./home.css";

import { Provider } from 'react-redux';
import { store } from "../../context/store";

const Home = () => {
  return (
      <Provider store={store}>
          <div className="home-page">
            <TabBar></TabBar>
            <div className="detail-view">
              <Outlet></Outlet>
            </div>
          </div>
      </Provider>
  );
};

export default Home;
